<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom:0;">
      <div class="row d-flex align-items-top ">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="check2-circle"></b-icon>
              Abnahmen
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- Neue Vergabeeinheit -->
          </div>
        </div>
      </div>
    </div>
    <div class="main-canvas">
      Diese Funktion ist in Kürze verfügbar.
    </div>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
export default {
  activated() {
    AppState.isLoading = false;
  }
};
</script>

<style scoped>
.page-header {
  border-bottom: 1px solid #dee2e6;
}
</style>
